// Historique d'une fiche patient : commentaires du robot (champs « robot.* ») et remarques de production PDA.

const ROBOT_FIELD_LABELS = {
    "robot.productionComment": "Commentaire production Robot",
    "robot.planningComment": "Commentaire onglet Robot",
};

export function robotHistoryFieldLabel(fieldName) {
    return ROBOT_FIELD_LABELS[fieldName] || null;
}

export function isRobotHistoryItem(item) {
    return String(item?.fieldName || "").startsWith("robot.");
}

export function isPdaCommentHistoryItem(item) {
    return isRobotHistoryItem(item) || item?.fieldName === "pdaProductionRemark";
}

export function pdaCommentHistoryItems(items) {
    return (items || []).filter(isPdaCommentHistoryItem);
}

export function historyItemComment(item) {
    return item?.newValue || "—";
}

// otherSource nomme l'origine des modifications qui ne viennent pas du robot (« PDA », « admin »…).
export function historyItemCommentWithSource(item, otherSource) {
    return `${historyItemComment(item)} (${isRobotHistoryItem(item) ? "robot" : otherSource})`;
}
